const Accordion = {
  parts: ["root", "button", "panel", "icon"],
  baseStyle: {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: "75"
    },
    button: {
      bg: "fill-component",
      px: "200",
      py: "75",
      borderRadius: "button",
      justifyContent: "space-between",
      _expanded: {
        borderRadius: "var(--vimeo-radii-button) var(--vimeo-radii-button) 0 0"
      }
    },
    panel: {
      bg: "fill-component",
      borderRadius: "0 0 var(--vimeo-radii-button) var(--vimeo-radii-button)",
      padding: "200",
      paddingTop: "100"
    }
  },
  sizes: {
    md: {
      button: {
        fontSize: "header-xs",
        fontWeight: "medium"
      },
      panel: {
        fontSize: "text-sm",
        fontWeight: "regular"
      }
    },
    lg: {
      button: {
        fontSize: "header-sm",
        fontWeight: "bold"
      },
      panel: {
        fontsize: "text-lg"
      }
    }
  },
  defaultProps: {
    size: "md"
  }
};

export { Accordion };
